export const fetchLessons = (product: string) => ({ type: "fetchLessons", product });

export const actions = {
  fetchLessons(context: any, { product }: { product: string }) {
    const lessons: any[] = require("../../../static/mv-university/available-lessons.json");
    return lessons.find((lesson) => lesson.key === product);
  },
};
